import { ArrowDown } from "lucide-react";
import { Mascot } from "@/components/Mascot";
import { Cta, TrustLine } from "@/components/public/PublicChrome";
import { HeroDemo } from "@/components/public/HeroDemo";
import { DESC } from "@/lib/publicContent";

function goToTour(e) {
  const el = document.getElementById("tour");
  if (!el) return;
  e.preventDefault();
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  el.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
  el.focus({ preventScroll: true });
}

export function HomeHero() {
  return (
    <section className="relative overflow-x-clip" aria-labelledby="hero-title" data-testid="home-hero">
      <div aria-hidden="true" className="hero-glow absolute left-1/2 -translate-x-1/2 top-80 h-[760px] w-[1400px] max-w-none -z-10 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 sm:pt-24 lg:pt-28">
        <div className="max-w-3xl rise">
          <p className="inline-flex items-center text-xs text-sky-300 border border-sky-400/30 bg-sky-400/10 rounded-full px-3 py-1" data-testid="hero-eyebrow">AI study tutor</p>
          <h1 id="hero-title" className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-semibold tracking-[-0.03em] leading-[1.03] mt-6" data-testid="hero-title">
            Get unstuck. <span className="text-neutral-400">Learn the method, not just the answer.</span>
          </h1>
          <p className="mt-6 text-base sm:text-lg text-neutral-300 max-w-2xl leading-relaxed" data-testid="hero-description">{DESC}</p>
          <div className="mt-9 flex flex-wrap items-center gap-3">
            <Cta testid="hero-signup-btn" />
            <a href="#tour" onClick={goToTour} data-testid="hero-tour-link"
              className="inline-flex items-center gap-2 rounded-full border border-white/15 px-6 py-3 text-sm text-neutral-200 hover:bg-white/[0.06] hover:border-white/25">
              See how it works <ArrowDown className="h-4 w-4" aria-hidden="true" />
            </a>
          </div>
          <TrustLine className="mt-5" testid="hero-trust-line" />
        </div>
        <figure className="relative mt-28 sm:mt-36 lg:mt-24 rise" style={{ animationDelay: "120ms" }} data-testid="hero-product-visual">
          <Mascot pose="full" eager className="absolute bottom-[calc(100%_-_14px)] right-4 sm:right-12 h-24 w-24 sm:h-32 sm:w-32 lg:h-40 lg:w-40 drop-shadow-[0_16px_36px_rgba(37,99,255,0.45)]" />
          <HeroDemo />
          <figcaption className="mt-4 text-xs text-neutral-500" data-testid="hero-product-caption">A photo of the problem, and the explanation it got. Recorded in the app, with pauses shortened.</figcaption>
        </figure>
      </div>
    </section>
  );
}
